import { useGetInteropCodesQuery } from '@/core/services/dmp-connect-js2'
import { InteropCode } from '@/core/types/dmp-connect'

function mapPracticeSettingsToOptions(practiceSettings?: InteropCode[]) {
  return (
    practiceSettings?.map((practiceSetting) => ({
      label: practiceSetting.s_displayName,
      value: practiceSetting.s_code,
    })) ?? []
  )
}

export function usePracticeSetting() {
  const { practiceSettings } = useGetInteropCodesQuery(
    { s_codeIds: ['practiceSettings'] },
    { selectFromResult: ({ data }) => ({ practiceSettings: mapPracticeSettingsToOptions(data?.practiceSettings) }) }
  )

  return { practiceSettings }
}
